import { useSearchParams } from "react-router-dom";
import { useAccount } from "wagmi";
import { useModal } from "connectkit";
import { Heart } from "lucide-react";
import { CATEGORIES } from "@/lib/categories";

export function CategoryBar() {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeCategory = searchParams.get("category") || "";
  const subscribed = searchParams.get("subscribed") === "true";
  const { address } = useAccount();
  const { setOpen } = useModal();

  const setCategory = (slug: string) => {
    const next = new URLSearchParams(searchParams);
    if (slug) {
      next.set("category", slug);
    } else {
      next.delete("category");
    }
    next.delete("topic");
    next.delete("subscribed");
    setSearchParams(next);
  };

  const toggleSubscribed = () => {
    if (!address) {
      setOpen(true);
      return;
    }
    const next = new URLSearchParams(searchParams);
    if (subscribed) {
      next.delete("subscribed");
    } else {
      next.set("subscribed", "true");
      next.delete("category");
      next.delete("topic");
    }
    setSearchParams(next);
  };

  return (
    <div className="border-b border-beige/20 overflow-x-auto scrollbar-hide">
      <div className="max-w-5xl mx-auto px-4 flex items-center gap-1 py-2">
        <button
          onClick={() => setCategory("")}
          className={`shrink-0 px-3 py-1.5 rounded-full text-sm font-body font-bold transition-colors ${
            activeCategory === "" && !subscribed
              ? "bg-orange text-white"
              : "text-grey hover:text-black hover:bg-beige/10"
          }`}
        >
          All
        </button>
        <button
          onClick={toggleSubscribed}
          className={`shrink-0 px-3 py-1.5 rounded-full text-sm font-body font-bold transition-colors inline-flex items-center gap-1 ${
            subscribed
              ? "bg-orange text-white"
              : "text-grey hover:text-black hover:bg-beige/10"
          }`}
        >
          <Heart size={14} />
          Subscribed
        </button>
        {CATEGORIES.map((cat) => (
          <button
            key={cat.slug}
            onClick={() => setCategory(cat.slug)}
            className={`shrink-0 px-3 py-1.5 rounded-full text-sm font-body font-bold transition-colors ${
              activeCategory === cat.slug && !subscribed
                ? "bg-orange text-white"
                : "text-grey hover:text-black hover:bg-beige/10"
            }`}
          >
            {cat.name}
          </button>
        ))}
      </div>
    </div>
  );
}
